angular.module('lsnBase.deprecated.models')
  .factory('PolicyDiscountModelConstants', ['LsnPolicyDiscountModelConstants', function(LsnPolicyDiscountModelConstants) {
    return LsnPolicyDiscountModelConstants;
  }])
  .factory('PolicyDiscountModel', ['LsnPolicyDiscountModelV1',
    function(LsnPolicyDiscountModelV1) {
      return LsnPolicyDiscountModelV1;
    }
  ]);